"use client"

import AssetComboIcon from "@src/components/DefuseSDK/components/Asset/AssetComboIcon"

const privacyTokens = [
  { symbol: "BTC", icon: "/static/icons/token/btc.svg" },
  { symbol: "ETH", icon: "/static/icons/network/ethereum.svg" },
  { symbol: "NEAR", icon: "/static/icons/token/near.svg" },
  { symbol: "SOL", icon: "/static/icons/network/solana.svg" },
  { symbol: "USDC", icon: "/static/icons/token/usdc.svg" },
  { symbol: "USDT", icon: "/static/icons/token/usdt.svg" },
  { symbol: "ZEC", icon: "/static/icons/token/zec.svg" },
  { symbol: "HYPE", icon: "/static/icons/network/hyperliquid.svg" },
  { symbol: "DOGE", icon: "/static/icons/network/dogecoin.svg" },
  { symbol: "TRX", icon: "/static/icons/network/tron.svg" },
  { symbol: "BNB", icon: "/static/icons/network/bsc.svg" },
] as const

export default function PrivacyTicker() {
  return (
    <div aria-hidden="true" className="relative h-28 overflow-hidden">
      <div className="mask-[linear-gradient(to_right,rgba(0,0,0,0.02),black_5%,black_95%,rgba(0,0,0,0.02))] flex h-full items-center [-webkit-mask-image:linear-gradient(to_right,rgba(0,0,0,0.02),black_5%,black_95%,rgba(0,0,0,0.02))]">
        <div className="flex w-max shrink-0 animate-[ticker-right_160s_linear_infinite] will-change-transform motion-reduce:animate-none">
          {[0, 1].map((copy) => (
            <div
              key={copy}
              className="dark flex shrink-0 items-center gap-14 px-7"
            >
              {privacyTokens.map((token) => (
                <AssetComboIcon
                  key={`${copy}-${token.symbol}`}
                  icon={token.icon}
                  sizeClassName="size-12"
                  className="shrink-0 rounded-full outline-1 outline-white/5"
                />
              ))}
            </div>
          ))}
        </div>
      </div>

      <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-1/2 overflow-hidden bg-gray-800/20 backdrop-blur-md backdrop-saturate-150">
        <div className="absolute inset-0 bg-linear-to-br from-white/6 via-transparent to-white/2" />

        <div className="absolute inset-y-0 left-0 w-px bg-white/10 shadow-[0_0_24px_rgba(255,255,255,0.08)]" />
      </div>
    </div>
  )
}
